import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { PqrDataSfcProps } from './props';
import { Accordion } from '../../../../../components/general/accordion';
import InfoIcon from '@mui/icons-material/Info';
import { usePqrDataSfc } from './hook';
import { Checkbox } from '../../../../../components/general/fields/checkbox';
import DateTimePickerField from '../../../../../components/general/fields/dateTimePickerField';

export const PqrDataSfc = ({
    dataSfc,
    hasReconsideration,
    status,
    gender,
    isLGBTIQ,
    half,
    dataReconsideration,
}: PqrDataSfcProps) => {
    const { formik, isDCF } = usePqrDataSfc(
        status,
        dataSfc,
        hasReconsideration,
        gender,
        isLGBTIQ,
        half,
        dataReconsideration
    );
    return (
        <Accordion
            title="INFORMACIÓN PQR SFC"
            icon={<InfoIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Canal qué presentó falla"
                        name="channelPresentsFailure"
                        size="small"
                        value={formik.values.channelPresentsFailure}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Checkbox
                        label="¿Es tutela?"
                        checked={Boolean(formik.values.isGuardianship)}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Número de tutela"
                        name="guardianship"
                        size="small"
                        value={formik.values.guardianship}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Ente de control"
                        name="controlEntity"
                        size="small"
                        value={formik.values.controlEntity}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Checkbox
                        label="Escalamiento DCF"
                        checked={Boolean(formik.values.dcfScaling)}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Checkbox
                        label="¿Es una reconsideración?"
                        checked={Boolean(formik.values.hasReconsideration)}
                    />
                </Grid>
                {isDCF && (
                    <Grid item xs={12} sm={4}>
                        <FieldText
                            label="Desistimiento"
                            name="desistd"
                            size="small"
                            value={formik.values.desistd}
                        />
                    </Grid>
                )}
                <Grid item xs={12} sm={4}>
                    <Checkbox
                        label="¿Es una queja express?"
                        checked={Boolean(formik.values.hasExpressComplaint)}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Instancia de recepción"
                        name="receptionInstance"
                        size="small"
                        value={formik.values.receptionInstance}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Punto de recepción"
                        name="receptionPoint"
                        size="small"
                        value={formik.values.receptionPoint}
                    />
                </Grid>
                {isDCF && (
                    <Grid item xs={12} sm={4}>
                        <FieldText
                            label="Admisión"
                            name="admission"
                            size="small"
                            value={formik.values.admission}
                        />
                    </Grid>
                )}
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Estado"
                        name="status"
                        size="small"
                        value={formik.values.status}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Checkbox
                        label="¿Es producto virtual?"
                        checked={Boolean(formik.values.isVirtualProduct)}
                    />
                </Grid>
                {isDCF && (
                    <>
                        <Grid item xs={12} sm={4}>
                            <FieldText
                                label="Aceptación"
                                name="acceptance"
                                size="small"
                                value={formik.values.acceptance}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FieldText
                                label="Rectificación"
                                name="rectification"
                                size="small"
                                value={formik.values.rectification}
                            />
                        </Grid>
                    </>
                )}
                <Grid item xs={12} sm={4}>
                    <Checkbox
                        label="¿Es prorroga?"
                        checked={Boolean(formik.values.isExtension)}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Checkbox
                        label="Anexos a la respuesta final"
                        checked={Boolean(formik.values.finalResponseAttached)}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Marcación"
                        name="marking"
                        size="small"
                        value={formik.values.marking}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Tipología de fraude"
                        name="fraudType"
                        size="small"
                        value={formik.values.fraudType}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Modalidad de fraude"
                        name="fraudMode"
                        size="small"
                        value={formik.values.fraudMode}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Monto reclamado"
                        name="claimedAmount"
                        size="small"
                        value={formik.values.claimedAmount}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Monto reconocido"
                        name="approvedAmount"
                        size="small"
                        value={formik.values.approvedAmount}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <DateTimePickerField
                        label="Fecha cierre DCF"
                        name="closingDateDCF"
                        size="small"
                        value={formik.values.closingDateDCF}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <DateTimePickerField
                        label="Fecha y hora radicación cliente"
                        name="customerFilingDate"
                        size="small"
                        value={formik.values.customerFilingDate}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <DateTimePickerField
                        label="Fecha actualización estado PQR"
                        name="updateStatusPQRDate"
                        size="small"
                        value={formik.values.updateStatusPQRDate}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <DateTimePickerField
                        label="Fecha respuesta SFC"
                        name="answerSFCDate"
                        size="small"
                        value={formik.values.answerSFCDate}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Genero"
                        name="gender"
                        size="small"
                        value={formik.values.gender}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Checkbox
                        label="¿Se identifica como LGBTIQ?"
                        checked={Boolean(formik.values.isLGBTIQ)}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Replica"
                        name="replica"
                        size="small"
                        value={formik.values.replica}
                    />
                </Grid>
                {hasReconsideration && (
                    <Grid item xs={12} sm={4}>
                        <FieldText
                            label="Código queja relacionado "
                            name="pqrReplica"
                            size="small"
                            value={formik.values.pqrReplica}
                        />
                    </Grid>
                )}
                <Grid item xs={12}>
                    <FieldText
                        label="Argumento de la replica"
                        name="observationsReplica"
                        size="small"
                        rows={3}
                        value={formik.values.observationsReplica}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
